export default "__VITE_ASSET__Dg9M$s5i__ 1000w";